"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var core_1 = require("@angular/core");
var PrettyJsonComponent = (function () {
    function PrettyJsonComponent() {
    }
    return PrettyJsonComponent;
}());
__decorate([
    core_1.Input()
], PrettyJsonComponent.prototype, "obj");
PrettyJsonComponent = __decorate([
    core_1.Component({
        selector: 'prettyjson',
        template: "\n    <pre [innerHtml]=\"obj | prettyjson\">\n    </pre>\n  ",
        styles: [
            "pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; }\n    :host >>> span {white-space: normal;}\n    :host >>> .string { color: green; }\n    :host >>> .number { color: darkorange; }\n    :host >>> .boolean { color: blue; }\n    :host >>> .null { color: magenta; }\n    :host >>> .key { color: red; }",
        ]
    })
], PrettyJsonComponent);
exports.PrettyJsonComponent = PrettyJsonComponent;



//////////////////
// WEBPACK FOOTER
// ./~/angular2-prettyjson/src/prettyjson.component.js
// module id = 305
// module chunks = 4